module.exports = __webpack_public_path__ + "img/crowdtwist.01c1c49.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/crowdtwist.png
// module id = R3TS
// module chunks = 38 43